import {Component} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import {MenuSectionService} from '../../../../provider/menu-section.service';
import {MenuService} from '../../../../provider/menu.service';
import {MenuSectionModel} from '../../../models/menu-section.model';
import {TranslateModel} from '../../../../core/_base/layout/models/translate.model';
import {LanguageTranslatePopup} from '../language-translate/language-translate.popup';
import {TranslationService} from '../../../../provider/translation.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'c-select-section',
  templateUrl: './select-section.popup.html',
  styleUrls: ['./select-section.popup.scss']
})
export class SelectSectionPopup {
  currentMenuSectionModel: MenuSectionModel;

  constructor(private dialogRef: MatDialogRef<SelectSectionPopup>,
              public menuSection: MenuSectionService,
              public menuService: MenuService,
              private dialog: MatDialog,
              public tra: TranslationService,
              public router: ActivatedRoute,
              public route: Router
              ) {
    // Hotel id service tarfında setlenmektedir. Otel id 0 gönderilmelidir.
    this.currentMenuSectionModel = new MenuSectionModel(
      0, 0, 100, false, false,
      '{"tr":"","en":"","de":"","fr":"","ru":"","ar":"","fa":""}', true);
  }

  close() {
    this.dialogRef.close(true);
  }

  addMenu() {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(this.currentMenuSectionModel.title);
    } catch (e) {
      translateModel = new TranslateModel();
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData: this.currentMenuSectionModel,
        key: 'title',
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      if (this.currentMenuSectionModel.title != '{"tr":"","en":"","de":"","fr":"","ru":"","ar":"","fa":""}') {
        this.menuSection.postSection(this.currentMenuSectionModel);
        this.currentMenuSectionModel = new MenuSectionModel(
          0, 0, 100, false, false,
          '{"tr":"","en":"","de":"","fr":"","ru":"","ar":"","fa":""}', true);
      } else {
        console.log('boş');
      }
    });

  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'MenuSection') {
      this.currentMenuSectionModel = baseData;
    } else {
      this.currentMenuSectionModel = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      if (this.currentMenuSectionModel != undefined) {
        this.menuSection.putSection(this.currentMenuSectionModel);
      }
      this.currentMenuSectionModel = new MenuSectionModel(
        0, 0, 42, false, false,
        '{"tr":"","en":"","de":"","fr":"","ru":"","ar":"","fa":""}', true);
    });
  }
}
